
    <div class="ModalContainer"
      [attr.data-drawer]="isDrawer"
    >
      <div class="ModalDialog"
        [attr.data-size]="size"
        [attr.data-drawer]="isDrawer"
      >
        <div class="ModalContent">
          <fl-icon class="ModalCloseButton"
            *ngIf="!hideCloseButton"
            [name]="'ui-close'"
            [size]="IconSize.SMALL"
            (click)="handleEscape()"
          ></fl-icon>
          <ng-container #modalContent></ng-container>
        </div>
      </div>
      <div class="ModalBackdrop"
        [attr.data-backdrop]="backdropActive"
        (click)="handleClick()"
      ></div>
    </div>
  